import React, { useState } from 'react';

const ProductsDropdown = ({ activeDropdown }) => {
  const [selectedCategory, setSelectedCategory] = useState('pumps');

  const productData = {
    pumps: [
      {
        id: "aurora-end-suction",
        name: "Aurora End Suction",
        price: "$3,148",
        priceNote: "Starting Price",
        image: "/images/auroraendsuction.png",
        badge: "Best Seller"
      },
      {
        id: 2,
        name: "Aurora Single Stage Vertical Inline Close",
        price: "$4,188",
        priceNote: "Starting Price",
        image: "/images/382B family.png.thumb.1280.1280.png",
        badge: ""
      },
      {
        id: 3,
        name: "Aurora Split Case Pumps",
        price: "$9,939",
        priceNote: "Starting Price",
        image: "/images/stage-split-casefull.png",
        badge: ""
      }
    ],
    accessories: [
      {
        id: 1,
        name: "Fairbanks Njihuis End Suction Pump",
        price: "REQUEST QUOTE",
        priceNote: "",
        image: "/images/nijhuis-end-suction.png",
        badge: ""
      },
      {
        id: 2,
        name: "Fairbanks Nijhuis Propellor Pump",
        price: "REQUEST QUOTE",
        priceNote: "",
        image: "/images/nijhuis-propellor-removebg-preview.png",
        badge: ""
      } 
    ],
    systems: [
      {
        id: 1,
        name: "Myers and Hydromatic Jet Pumps",
        price: "REQUEST QUOTE",
        priceNote: "",
        image: "/images/JETPUMPS.png",
        badge: "Popular"
      },
      {
        id: 2,
        name: "Myers and Hydromatic Centrifugal Pumps",
        price: "$8,500",
        priceNote: "Starting Price",
        image: "/images/centrifugal-pumps.png",
        badge: ""
      }
    ]
  };

  const categories = {
    pumps: "Aurora Pumps",
    accessories: "Fairbanks Nijhuis Products", 
    systems: "Myers Products"
  };

  if (activeDropdown !== 'products') return null;

  return (
    <div className="products-dropdown-overlay">
      <div className="products-dropdown-container">
        {/* Left Sidebar - Categories */}
        <div className="dropdown-sidebar">
          <ul className="category-list">
            {Object.entries(categories).map(([key, label]) => (
              <li key={key}>
                <button 
                  className={`category-item ${selectedCategory === key ? 'active' : ''}`}
                  onClick={() => setSelectedCategory(key)}
                >
                  {label}
                </button>
              </li>
            ))}
          </ul>
          
          <div className="sidebar-links">
            <a href="/products" className="sidebar-link">View All Products</a>
          </div>
        </div>

        {/* Right Content - Product Grid */}
        <div className="dropdown-content">
          <div className="content-header">
            <h2 className="content-title">{categories[selectedCategory]}</h2>
          </div>
          <div className="products-grid">
            {productData[selectedCategory]?.map((product) => (
              <a 
                key={product.id} 
                href={`/products/${product.id}`} 
                className="product-item-link"
              >
                <div className="product-item">
                  {product.badge && (
                    <span className={`product-badge ${product.badge.toLowerCase()}`}>
                      {product.badge}
                    </span>
                  )}
                  
                  <div className="product-image-container">
                    <img 
                      src={product.image} 
                      alt={product.name}
                      className="product-image"
                    />
                  </div>
                  
                  <div className="product-info">
                    <div className="product-price-note">{product.priceNote}</div>
                    <h3 className="product-title">{product.name}</h3>
                    <div className="product-price">{product.price}</div>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductsDropdown;